import { AdCreativeType } from '@marketing-milk/interfaces'
import React from 'react'
import ReactSelect from 'react-select'

export type Props = {
  onSelectType: (type: AdCreativeType) => void
  value?: `${AdCreativeType}`[]
  placeholder?: string
  disableMulti?: boolean
}
export const SelectCreativeType = (props: Props) => (
  <ReactSelect
    isMulti={!props.disableMulti}
    value={props.value?.map(value => ({ label: value, value }))}
    isClearable
    options={Object.values(AdCreativeType).map(status => ({
      label: status,
      value: status,
    }))}
    placeholder={props.placeholder}
    // @ts-ignore
    onChange={selections => props.onSelectType(selections.map(({ value }) => value))}
  />
)
